import TableComponent from "app/common/Component/Table/TableComponent";
import { useStore } from "app/stores";
import React, { memo } from "react";
import { Grid, Tooltip } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import {
  getAge,
  getCurrentStaff,
  getDate,
  getDateTime,
  getGender,
  hideMiddleDigits,
  isAdmin,
  isRoleHisReadOnly,
} from "app/common/LocalFunction";
import CopyableCodeCell from "app/common/Component/CopyableCodeCell";
import IconPen from "app/common/Icon/IconPen";
import { observer } from "mobx-react";
import { APPOINTMENT_STATUS, APPOINTMENT_TYPE } from "app/common/LocalConst";
import GlobitsSelectInput from "app/common/form/GlobitsSelectInput";
import { useFormikContext } from "formik";
// import ConfirmPopup from "app/common/Component/Popup/ConfirmPopup";
// import AppointmentStatusAndCheckIn from "app/PatientManagement/AppointmentList/Popup/AppointmentStatusAndCheckIn";
import useDefaultDepartment from "app/common/hooks/useDefaultDepartment";
import { CheckCircle, RemoveCircleOutline } from "@material-ui/icons";
const ListAppointment = ({ departmentId }) => {
  const { t } = useTranslation();
  const { resetForm, setFieldValue } = useFormikContext();
  const {
    searchAppointment,
    pageAppointment,
    handleChangeFormSearchTab,
    handleOpenFormCreateOrEdit,
  } = useStore().patientManagementStore.appointmentStore;
  const defaultDepartment = useDefaultDepartment();
  const renderBirthDate = (patient) => {
    if (!patient?.birthDate && !patient?.age) return null;

    return (
      <span>
        {patient?.birthDate && getDate(patient.birthDate)}
        {patient?.age && (
          <>
            {" "}
            <small>({getAge(patient.birthDate)})</small>
          </>
        )}
      </span>
    );
  };
  const isReadonly = isRoleHisReadOnly();
  let isAdminPermission = isAdmin();
  return (
    <>
      <Grid
        container
        spacing={1}
        className="justify-center cards-body pt-0 mt-2"
        style={{
          zIndex: 1,
          position: "relative",
        }}
      >
        <Grid item xs={12}>
          <TableComponent
            className=""
            showOrdinalNumbers
            titleNodata={t("noData")}
            data={pageAppointment?.content}
            minWidth={"720px"}
            name="AppointmentListDataBlock"
            showMoreButton
            columns={[
              !isReadonly && {
                title: t("action"),
                field: "action",
                align: "center",
                render: (patient) => (
                  <div className="flex-center gap-2">
                    {isAdminPermission && (
                      <Tooltip title="Chỉnh sửa">
                        <div
                          className="flex"
                          onClick={() => {
                            handleOpenFormCreateOrEdit(patient);
                          }}
                        >
                          <IconPen />
                        </div>
                      </Tooltip>
                    )}
                    {/* <Tooltip title="Hủy check in">
                  <div
                    className="flex"
                    onClick={() => {
                      handleDeleteCheckIn(patient);
                    }}
                  >
                    <IconDelete />
                  </div>
                </Tooltip> */}
                  </div>
                ),
              },
              {
                field: "appointmentCode",
                title: t("Mã đặt lịch"),
              },
              {
                field: "age",
                title: t("Thời gian bắt đầu"),
                render: (val) => getDateTime(val?.startTime),
              },
              {
                field: "patient.displayName",
                width: "260px",
                title: t("Tên khách hàng"),
                render: (row) => (
                  <div>
                    <Tooltip title="Thông tin khách hàng">
                      <div>
                        <p>
                          <b>{row?.patient?.displayName}</b>
                        </p>
                        <p>
                          <>
                            <b style={{ color: "#4276a4" }}>
                              <CopyableCodeCell value={row?.patient?.code} size="small" />{" "}
                            </b>
                            {row?.patient?.gender && (
                              <>|{getGender(row?.patient?.gender)}</>
                            )}
                          </>
                        </p>
                      </div>
                    </Tooltip>
                  </div>
                ),
              },

              {
                field: "isReminded",
                title: t("Đã nhắc lịch hẹn"),
                align: "center",
                render: (rowData) =>
                  rowData?.isReminded ? (
                    <Tooltip title="Đã nhắc lịch hẹn" arrow>
                      <CheckCircle style={{ color: "#4caf50", fontSize: 20 }} />
                    </Tooltip>
                  ) : (
                    <Tooltip title="Chưa nhắc lịch hẹn" arrow>
                      <RemoveCircleOutline
                        style={{ color: "#9e9e9e", fontSize: 20, opacity: 0.6 }}
                      />
                    </Tooltip>
                  ),
              },

              {
                field: "noteReminded",
                title: t("Note tương tác lịch hẹn"),
                width: "160px",
              },

              {
                field: "reminderAgent",
                title: t("Người nhắc lịch hẹn"),
                width: "160px",
                render: (val) => (
                  <span>
                    {val?.reminderAgent?.staffName}
                  </span>
                ),
              },


              {
                field: "age",
                title: t("Ngày sinh"),
                render: (val) => renderBirthDate(val?.patient),
                width: "160px",
              },

              {
                field: "patient.phoneNumber",
                width: "160px",
                title: t("Số điện thoại"),
                render: (val) => (
                  <span className="name-medical">
                    {hideMiddleDigits(val?.patient?.phoneNumber)}
                  </span>
                ),
              },
              {
                title: t("Cơ sở"),
                render: (val) => val?.department?.name,
              },
              {
                field: "currentVisitDepName",
                title: t("Loại đặt lịch"),
                render: (row) =>
                  APPOINTMENT_TYPE.find(
                    (el) => el.value === row?.appointmentType
                  )?.name || "",
              },
              {
                field: "status",
                title: t("Trạng thái"),
                width: "200px",
                align: "center",
                render: (row) =>
                  APPOINTMENT_STATUS.find((el) => el.value === row?.status)
                    ?.name || "",
              },
              {
                field: "leadSource.name",
                title: t("Nguồn"),
              },
              {
                field: "leadSourceDetail.name",
                title: t("Nguồn chi tiết"),
              },
              {
                field: "telesale.staffName",
                title: t("Telesale"),
              },
              {
                field: "checkinTime",
                title: t("Thời gian check-in"),
                render: (row) => getDateTime(row?.checkinTime)
                // row?.status === APPOINTMENT_STATUS[2].value
                // ? getDateTime(row?.checkinTime)
                // : "",
              },
              {
                field: "note",
                title: t("Ghi chú"),
                width: "800px",
                render: (val) => (
                  <div
                    style={{
                      maxHeight: "10em",
                      overflowY: "auto",
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                      paddingRight: "4px",
                      lineHeight: "1.6em",
                    }}
                  >
                    <i>{val?.note}</i>
                  </div>
                ),
              },
            ].filter(Boolean)}
            dataPagination={{
              pageIndex: searchAppointment?.pageIndex,
              pageSize: searchAppointment?.pageSize,
              totalElements: pageAppointment?.totalElements,
              totalPages: pageAppointment?.totalPages,
              setPageIndex: (pageIndex) =>
                handleChangeFormSearchTab({ pageIndex }),
              setPageSize: (pageSize) =>
                handleChangeFormSearchTab({ pageSize }),
            }}
          />
          {/* {!!openConfirmUpdateState && (
          <ConfirmPopup
            open={!!openConfirmUpdateState}
            onClose={() => {
              handleUpdateAppointmentStatus(null);
              resetForm();
            }}
            text={`Bạn có chắc chắn muốn cập nhật lịch hẹn thành ${
              APPOINTMENT_STATUS?.find(
                (el) => el.value === openConfirmUpdateState?.status
              )?.name || ""
            } không ?`}
            onConfirm={updateAppointmentStatus}
          />
        )}
        {openAppointmentStatusAndCheckin && (
          <AppointmentStatusAndCheckIn
            open={openAppointmentStatusAndCheckin}
            handleClose={() => {
              handleUpdateAppointmentStatusAndCheckin(null);
              resetForm();
            }}
            handleSubmit={updateAppointmentStatusAndCheckIn}
            initialValues={{
              ...openAppointmentStatusAndCheckin,
              department: defaultDepartment,
              checkinTime: new Date(),
              checkInAgent: getCurrentStaff(),
            }}
          />
        )} */}
        </Grid>
      </Grid>
    </>
  );
};

export default memo(observer(ListAppointment));
